import Vue from "vue";
import locale from "element-ui/lib/locale/lang/en";
// import locale from 'element-ui/lib/locale'
import {
  Button,
  Form,
  FormItem,
  Pagination,
  Loading,
  Input,
  Select,
  Radio,
  Option,
  Dialog,
  Message,
  Collapse,
  CollapseItem,
  CheckboxGroup,
  CheckboxButton,
} from "element-ui";
const components = [
  Form,
  FormItem,
  Button,
  Pagination,
  Input,
  Select,
  Radio,
  Option,
  Dialog,
  Collapse,
  CollapseItem,
  CheckboxGroup,
  CheckboxButton
];

const Element = {
  install(Vue) {
    components.forEach((component) => {
      Vue.component(component.name, component);
    });
  },
};
Vue.use(Loading.directive);
Vue.use(Element, {
  locale,
});
Vue.prototype.$message = Message;
